import { render } from "./main_layout.vue?vue&type=template&id=2bb661f4"
import script from "./main_layout.vue?vue&type=script&lang=js"
export * from "./main_layout.vue?vue&type=script&lang=js"

import "./main_layout.vue?vue&type=style&index=0&id=2bb661f4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__